<script setup lang="ts">
import type { SelectRootEmits, SelectRootProps } from 'reka-ui';

import { SelectRoot, useForwardPropsEmits } from 'reka-ui';

const props = defineProps<SelectRootProps>();
const emits = defineEmits<SelectRootEmits>();

const forwarded = useForwardPropsEmits(props, emits);
const selectRef = ref<HTMLButtonElement | null>(null);

defineExpose({
	selectRef
});
</script>

<template>
	<SelectRoot v-bind="forwarded" ref="selectRef" class="border-none">
		<slot></slot>
	</SelectRoot>
</template>
